import { toPurchaseHistoryOrderPath } from "features/purchaseHistory/purchaseHistoryOrderPath";
import { toPayType } from "features/purchaseHistory/purchaseHistoryOrderValues";

import { PAYMENT_STATUS } from "../../constants/paymentStatus";
import { getImagePath } from "../getImagePath";

import type { ParsedSettlement } from "../../types/parsedSettlement";
import type { ConvertedSettlement } from "./props";
import type { PaymentStatus } from "@spwn/types";

const paymentStatusRecord: Record<string, PaymentStatus | undefined> =
  PAYMENT_STATUS;

const parsePaymentStatus = (value: unknown): PaymentStatus | null => {
  if (typeof value !== "string") return null;
  return paymentStatusRecord[value] ?? null;
};

type CalculatePurchasedCount = (settlement: ParsedSettlement) => number;

const calculatePurchasedCount: CalculatePurchasedCount = (settlement) => {
  if (Array.isArray(settlement.lineItems)) {
    return settlement.lineItems.reduce(
      (totalCount, item) => totalCount + item.quantity,
      0
    );
  }

  if (!Array.isArray(settlement.products)) {
    return 0;
  }

  return settlement.products.reduce(
    (totalCount, product) => totalCount + product.count,
    0
  );
};

type CheckHasGoods = (settlement: ParsedSettlement) => boolean;

// グッズが含まれているか判定
// OrderTransaction は全てグッズ扱い
// それ以外は products 内に goods があるかチェック
const checkHasGoods: CheckHasGoods = (settlement) => {
  if (Array.isArray(settlement.lineItems)) {
    return true;
  }

  if (!Array.isArray(settlement.products)) {
    return false;
  }

  // TODO: "goods"などのtypeは定数化する
  return settlement.products.some((product) => product.productType === "goods");
};

type ConvertSettlementToCardProps = (
  settlement: ParsedSettlement
) => ConvertedSettlement;

export const convertSettlementToCardProps: ConvertSettlementToCardProps = (
  settlement
) => {
  const orderId = settlement.orderId?.toString() ?? "";
  const purchasedAt = settlement.createdAt?.toDate().getTime() ?? 0;
  const purchasedCount = calculatePurchasedCount(settlement);
  const imagePath = getImagePath(settlement);

  const hasGoods = checkHasGoods(settlement);

  const paymentStatus = parsePaymentStatus(settlement.status);
  const paymentType = toPayType(settlement.payType);

  return {
    hasGoods,
    imagePath,
    linkTo: toPurchaseHistoryOrderPath(orderId),
    orderId,
    paymentStatus,
    paymentType,
    purchasedAt,
    purchasedCount,
  };
};
